// apps/patient/src/constants/equipment.ts
// Equipment categories for location management
// Matches the categories used in provider RoutineBuilder

export const EQUIPMENT_CATEGORIES: Record<string, string[]> = {
  'No Equipment / Bodyweight': [
    'Bodyweight', 'At Home', 'Wall', 'Chair', 'Table', 'Books', 'Towel', 'Tennis Ball'
  ],
  'Free Weights': [
    'Dumbbell', 'Barbell', 'Kettlebell', 'EZ Bar', 'EZ-Bar', 'EZ Barbell',
    'Olympic Barbell', 'Weight Plate', 'Weight Plates', 'Weighted', 'Medicine Ball',
    'Sandbag', 'Weight Vest'
  ],
  'Resistance Bands & Cables': [
    'Resistance Band', 'Resistance Band (Long)', 'Resistance Band (Short)',
    'Resistance Band with Handle', 'Resistance Bands 1', 'Cable System',
    'Single Cable', 'Double Cable', 'Cable Row Machine', 'Cable-Lat Pulldown Machine'
  ],
  'Benches & Seats': [
    'Bench', 'Bench 2', 'Bench 3', 'Incline Bench', 'Incline Bench 2',
    'Decline Bench', 'Tall Bench', 'Seat', 'Seat 2', 'Bench with Leg Grips',
    'Prone Row Bench'
  ],
  'Pull-up & Dip Equipment': [
    'Pull Up Bar', 'Pull-Up Bar', 'Pull-up Bar', 'Dip Bars', 'Assisted Pull Up Machine',
    'Assisted Dip Machine', "Captain's Chair", 'Captains Chair', 'Parallel Bars'
  ],
  'Cardio Machines': [
    'Treadmill', 'Elliptical', 'Elliptical Machine', 'Stationary Bike',
    'Recumbent Bike', 'Air Bike', 'Hand Bike', 'Row Machine', 'Rowing Machine',
    'Ski Ergometer', 'Stepmill Machine', 'Walk Wave Machine'
  ],
  'Racks & Machines': [
    'Rack', 'Smith Machine', 'Machine', 'Leverage Machine', 'Power Sled'
  ],
  'Stability & Balance': [
    'Stability Ball', 'Exercise Ball', 'Bosu Ball', 'Balance Exercise', 'Vibrate Plate'
  ],
  'Mobility & Recovery': [
    'Foam Roller', 'Muscle Roller Stick', 'Tiger Tail', 'Myofascial Release Ball',
    'Yoga Block', 'Wheel Roller'
  ],
  'Functional Training': [
    'Box', 'Step', 'Jump Rope', 'Battle Rope', 'Climbing Rope',
    'Rope', 'Cones', 'Hurdle', 'Slider', 'Suspension',
    'Rings', 'Gymnastic Rings', 'Tire', 'Mat'
  ]
};

// Quick presets for common setups
export const EQUIPMENT_PRESETS: Record<string, string[]> = {
  'Bodyweight Only': ['Bodyweight', 'Wall', 'Chair', 'Mat'],
  'Home Basic': [
    'Bodyweight', 'Wall', 'Chair', 'Mat',
    'Dumbbell', 'Resistance Band', 'Foam Roller'
  ],
  'Home Gym': [
    'Bodyweight', 'Wall', 'Chair', 'Mat',
    'Dumbbell', 'Barbell', 'Kettlebell', 'Weight Plate',
    'Resistance Band', 'Pull Up Bar', 'Bench', 'Foam Roller'
  ],
  'Full Commercial Gym': Object.values(EQUIPMENT_CATEGORIES).flat()
};

// Location type icons
export const LOCATION_TYPE_ICONS: Record<string, string> = {
  home: '🏠',
  commercial_gym: '🏋️',
  workplace: '🏢',
  outdoor: '🌳',
  clinic: '🏥',
  other: '📍'
};

export const LOCATION_TYPE_LABELS: Record<string, string> = {
  home: 'Home',
  commercial_gym: 'Commercial Gym',
  workplace: 'Workplace',
  outdoor: 'Outdoor',
  clinic: 'Clinic',
  other: 'Other'
};
